export var HeadingFormatOptionLabel;
(function (HeadingFormatOptionLabel) {
    HeadingFormatOptionLabel["NORMAL"] = "Normal Text";
    HeadingFormatOptionLabel["H1"] = "Heading 1";
    HeadingFormatOptionLabel["H2"] = "Heading 2";
    HeadingFormatOptionLabel["H3"] = "Heading 3";
    HeadingFormatOptionLabel["H4"] = "Heading 4";
})(HeadingFormatOptionLabel || (HeadingFormatOptionLabel = {}));
export var HeadingFormatCommandOption;
(function (HeadingFormatCommandOption) {
    HeadingFormatCommandOption[HeadingFormatCommandOption["NORMAL"] = 0] = "NORMAL";
    HeadingFormatCommandOption[HeadingFormatCommandOption["H1"] = 1] = "H1";
    HeadingFormatCommandOption[HeadingFormatCommandOption["H2"] = 2] = "H2";
    HeadingFormatCommandOption[HeadingFormatCommandOption["H3"] = 3] = "H3";
    HeadingFormatCommandOption[HeadingFormatCommandOption["H4"] = 4] = "H4";
})(HeadingFormatCommandOption || (HeadingFormatCommandOption = {}));
export const HEADING_LEVEL_MAP = {
    0: HeadingFormatOptionLabel.NORMAL,
    1: HeadingFormatOptionLabel.H1,
    2: HeadingFormatOptionLabel.H2,
    3: HeadingFormatOptionLabel.H3,
    4: HeadingFormatOptionLabel.H4,
};
export const headingFormatOptions = [
    {
        label: HeadingFormatOptionLabel.NORMAL,
        value: {
            key: HeadingFormatOptionLabel.NORMAL,
            keyArray: [HeadingFormatOptionLabel.NORMAL],
            label: HeadingFormatOptionLabel.NORMAL,
            description: 'Use normal text formatting',
            commandOption: HeadingFormatCommandOption.NORMAL,
            optionLabelStyle: {
                headingFontFamily: false,
                fontSize: 'medium',
            },
            analyticsId: 'normal-text',
        },
    },
    {
        label: HeadingFormatOptionLabel.H1,
        value: {
            key: HeadingFormatOptionLabel.H1,
            keyArray: [HeadingFormatOptionLabel.H1],
            label: HeadingFormatOptionLabel.H1,
            description: 'Use heading 1 formatting',
            commandOption: HeadingFormatCommandOption.H1,
            optionLabelStyle: {
                headingFontFamily: true,
                fontSize: 'large',
            },
            analyticsId: 'heading-1',
        },
    },
    {
        label: HeadingFormatOptionLabel.H2,
        value: {
            key: HeadingFormatOptionLabel.H2,
            keyArray: [HeadingFormatOptionLabel.H2],
            label: HeadingFormatOptionLabel.H2,
            description: 'Use heading 2 formatting',
            commandOption: HeadingFormatCommandOption.H2,
            optionLabelStyle: {
                headingFontFamily: true,
                fontSize: 'mediumLarge',
            },
            analyticsId: 'heading-2',
        },
    },
    {
        label: HeadingFormatOptionLabel.H3,
        value: {
            key: HeadingFormatOptionLabel.H3,
            keyArray: [HeadingFormatOptionLabel.H3],
            label: HeadingFormatOptionLabel.H3,
            description: 'Use heading 3 formatting',
            commandOption: HeadingFormatCommandOption.H3,
            optionLabelStyle: {
                headingFontFamily: true,
                fontSize: 'notQuiteAllTheWayMediumLarge',
            },
            analyticsId: 'heading-3',
        },
    },
    {
        label: HeadingFormatOptionLabel.H4,
        value: {
            key: HeadingFormatOptionLabel.H4,
            keyArray: [HeadingFormatOptionLabel.H4],
            label: HeadingFormatOptionLabel.H4,
            description: 'Use heading 4 formatting',
            commandOption: HeadingFormatCommandOption.H4,
            optionLabelStyle: {
                headingFontFamily: true,
                fontSize: 'medium',
            },
            analyticsId: 'heading-4',
        },
    },
];
//# sourceMappingURL=text_heading_dropdown.js.map